import {Grid} from "semantic-ui-react";
import React from "react";
import {observer} from "mobx-react-lite";
import FieldName from "./FieldName";
import FieldValue from "./FieldValue";
import IHasIdAndName from "../../Entities/IHasIdAndName";
import FieldIdSelector from "./FieldIdSelector";
import {SemanticWIDTHS} from "semantic-ui-react/dist/commonjs/generic";

function FieldWithFieldIdSelector(props: {
    name: string,
    value?: string,
    fields: IHasIdAndName[],
    onChange(value?: string): void,
    onSearchChange?(value: string): void,
    notClearable?: boolean
    required?: boolean,
    tip?: string,
    placeholder?: string,
    visible?: boolean,
    noResultsMessage?: React.ReactNode,
    search?: boolean,
    nameWidth?: SemanticWIDTHS,
    fieldWidth?: SemanticWIDTHS,
}) {
    const {
        name, value, fields, onChange,
        notClearable, required,
        tip, placeholder,
        onSearchChange,
        noResultsMessage,
        search,
        nameWidth,
        fieldWidth
    } = props;

    if (props.visible !== undefined) {
        if (!props.visible) {
            return <></>;
        }
    }

    return <Grid.Row>
        <FieldName width={nameWidth} name={name} required={required}/>
        <FieldValue width={fieldWidth} style={tip && {display: 'flex'}}>
            <FieldIdSelector 
                value={value}
                fields={fields}
                onChange={onChange}
                onSearchChange={onSearchChange}
                notClearable={notClearable}
                tip={tip}
                placeholder={placeholder}
                noResultsMessage={noResultsMessage}
                search={search}
            />
        </FieldValue>
    </Grid.Row>
}




export default observer(FieldWithFieldIdSelector);
